import * as React from 'react'
import { History, Location } from 'history'
import { GallerySort, parseGallerySort, serializeGallerySort } from './gallerySortParams'

interface UseGallerySortResult {
  sort: GallerySort
  apply: (next: GallerySort) => void
}

export const useGallerySort = (
  location: Location,
  history: History,
  { hasAlbum }: { hasAlbum: boolean }
): UseGallerySortResult => {
  const sort = React.useMemo(
    () => parseGallerySort(location.search, { hasAlbum }),
    [location.search, hasAlbum]
  )

  const apply = React.useCallback(
    (next: GallerySort) => {
      const search = serializeGallerySort(next, location.search)
      // replace, not push: the menu applies on every click, so pushing would bury the
      // previous page under one history entry per option toggled
      history.replace({ pathname: location.pathname, search: search ? `?${search}` : '' })
      // the gallery reloads from index 0; a kept scroll offset would land mid-list
      window.scrollTo({ top: 0 })
    },
    [history, location.pathname, location.search]
  )

  return { sort, apply }
}
